import { useCallback } from 'react';

import { useOnboardingStore, useUpdateUser } from '@/entities/user/currentUser';

export const useUpdateOnboardingSteps = () => {
  const currentStep = useOnboardingStore((state) => state.currentStep);
  const prevSteps = useOnboardingStore((state) => state.prevSteps);
  const closeCurrentStep = useOnboardingStore((state) => state.closeCurrentStep);
  const { mutate: updateUser } = useUpdateUser();

  return useCallback(() => {
    if (currentStep) {
      const updatedOnboarding = new Set([currentStep, ...prevSteps]);

      updateUser({ onboarding: [...updatedOnboarding] });
      closeCurrentStep();
    }
  }, [closeCurrentStep, prevSteps, currentStep, updateUser]);
};
